// @file Entrypoint for the workspace (library) login redirect verification page
import { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import { useAuthLibraryVerificationStore } from '@@/pinia/auth_library_verification_store'
import AuthLibraryVerificationApp from '@@/vuecomponents/AuthLibraryVerificationApp.vue'

void setupVueApp({
  el: '#auth_library_verification_app',
  rootComponent: AuthLibraryVerificationApp,
  usePinia: true,
  initializePiniaStore() {
    useAuthLibraryVerificationStore().initialize(ww.vueStartingState)
  },
})
